var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames, firstStringProperty } from '@shapeable/utils';
var cls = classNames('entity-color-label');
export var defaultEntityColorLabelPaths = ['title', 'name'];
export var EntityColorLabelDefaultProps = {
  paths: defaultEntityColorLabelPaths
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: ", ";\n    font-weight: 600;\n    \n    ", "\n  "], ["\n    font-size: ", ";\n    font-weight: 600;\n    \n    ", "\n  "])), theme.FONT_SIZE(12), function (_a) {
    var _color = _a._color;
    return _color && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), _color);
  })
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var EntityColorLabel = function (props) {
  var _a;
  var className = props.className,
    children = props.children,
    paths = props.paths,
    entity = props.entity;
  var color = (_a = entity.color) === null || _a === void 0 ? void 0 : _a.value;
  var label = firstStringProperty(entity, paths);
  return React.createElement(My.Container, {
    _color: color,
    className: cls.name(className)
  }, label || children);
};
EntityColorLabel.defaultProps = EntityColorLabelDefaultProps;
EntityColorLabel.cls = cls;
var templateObject_1, templateObject_2, templateObject_3;